window.addEventListener('load', () => {
	let slider = document.querySelector('.announcement-bar-section');
	let slides = document.querySelectorAll('.announcement-bar');

	for (let i = 0; i < slides.length; i++) {
		slides[i].style.display = 'none';
	}
	slides[0].style.display = 'block';

	let count = 1;
	setInterval(() => {
		if (count < slides.length) {
			for (let i = 0; i < slides.length; i++) {
				slides[i].style.display = 'none';
			}
			slides[count].style.display = 'block';
			count++;
			if (count == slides.length) {
				count = 0;
			}
		}
	}, 5000)
});